import React from "react";
import "./Announcement.css";

const Announcement = () => {
  return (
    <div className="announcement-page">
      <div className="announcement-container">
        <div className="announcement-header">
          <h1>BoomLand Official Announcement</h1>
          <p className="announcement-date">January 2026</p>
        </div>

        <div className="announcement-content">
          <p className="announcement-intro">
            To our community, players, partners, and investors,
          </p>

          <p>This is an incredibly difficult message for us to share.</p>

          <p>
            After extensive efforts to continue operating BoomLand, we have made
            the decision to close the project. Despite doing everything within
            our control to sustain operations, we are no longer able to
            continue. This decision was not taken lightly.
          </p>

          <p>
            Over a long period of time, we explored multiple paths forward,
            reduced costs aggressively, and continued operating far longer than
            was financially rational because we genuinely believed in the
            project and in the community behind it. We fought hard to keep
            BoomLand alive, and we stayed committed for as long as it was
            realistically possible.
          </p>

          <p>
            We want to sincerely thank everyone who supported BoomLand through
            both the good and the difficult periods. We were fortunate to have
            an incredibly dedicated, passionate, and supportive community, one
            that believed deeply in what we were trying to build and stood by us
            even when the road was not easy. Your trust, time, patience, and
            belief meant a great deal to us, and we do not take that lightly.
          </p>

          <h2>Operational Timeline</h2>

          <p>
            Hunters On Chain will remain live for the next{" "}
            <strong>12 months from today</strong>. During this period:
          </p>

          <ul>
            <li>Players can continue playing the game</li>
            <li>
              In-game assets and the $BOOM token will remain usable within the
              existing ecosystem
            </li>
            <li>Trading and gameplay will function as they do today</li>
          </ul>

          <p>
            After this 12-month period, the servers will be permanently shut
            down.
          </p>

          <p>
            Due to limited resources, Discord moderation and active community
            support will end effectively immediately. While the server may
            remain accessible for a short period, it will no longer be actively
            moderated or supported.
          </p>

          <h2>Closing Note</h2>

          <p>
            The past market cycle has been exceptionally challenging for Web3
            gaming. Many projects with significantly more funding and larger
            teams were unable to survive it. While this is not the outcome we
            hoped for, we are proud that BoomLand remained live, functional, and
            player-facing for as long as it did, and that we delivered a real
            on-chain game rather than just promises.
          </p>

          <p>
            We continue to believe in the fundamentals of Web3 technology.
            Unfortunately, market dynamics, capital conditions, and broader
            industry instability made it impossible for us to continue.
          </p>

          <p className="announcement-closing">
            Thank you for being part of this journey and for everything you
            contributed along the way. We are genuinely grateful to everyone who
            believed in BoomLand and shared this path with us.
          </p>

          <p className="announcement-signature">
            <strong>BoomLand Team</strong>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Announcement;
